export default __webpack_public_path__ + "static/TTCommons-Regular-dcfd1567a171a24deb54095807b90cf6.woff2";